// extracted by mini-css-extract-plugin
module.exports = {"appList":"AppList_appList__o0e0e","row":"AppList_row__xjPb8","serviceIcon":"AppList_serviceIcon__PAg_m"};